import { identifiers, tabLabels, buttonIds } from 'components/FreecodePage/FreecodeLayoutConstants';

const TOUR_DATA = [
  {
    title: 'Description',
    text: 'Click here to view the description.',
    elementId: tabLabels[identifiers.description].tabId,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'Summary',
    text: 'Click here to view the summary displayed on the landing page.',
    elementId: tabLabels[identifiers.summary].tabId,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'API Methods',
    text: 'Click here to view the available API methods.',
    elementId: tabLabels[identifiers.api].tabId,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'Select Language',
    text: 'Click here to select your preferred programming language.',
    elementId: buttonIds.selectLanguage,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'Run Code',
    text: 'Click here to run your code and see how it performs on test levels.',
    elementId: buttonIds.runButton,
    arrow: 'right',
    heightMultiplier: 0.5,
    widthMultiplier: -1,
  },
  {
    title: 'Console',
    text: 'When you run your code, console output will appear here.',
    elementId: tabLabels[identifiers.console].tabId,
    heightMultiplier: 0,
    widthMultiplier: 0.5,
    arrow: 'bottom',
  },
  {
    title: 'Score',
    text: 'When you run your code, your score per level can be seen here.',
    elementId: tabLabels[identifiers.score].tabId,
    heightMultiplier: 0,
    widthMultiplier: 0.5,
    arrow: 'bottom',
  },
  {
    title: 'Canvas',
    text: 'After running your code a replay of your programs behaviour will be shown here.',
    elementId: 'freecodePlayer',
    widthMultiplier: 1,
    heightMultiplier: 0.5,
    arrow: 'left',
    wideScreen: {
      widthMultiplier: 0,
      arrow: 'right',
    },
  },
  {
    title: 'Submit Code',
    text: 'Once you feel confident about your solution, click here to submit it and have it scored on the evaluation levels. Note that these levels differ from the test levels in the bottom left corner of the screen.',
    elementId: buttonIds.submitButton,
    arrow: 'right',
  },
  {
    title: 'Help Overlay',
    text: 'You can restart this tour overlay from here.',
    elementId: buttonIds.helpButton,
    heightMultiplier: 0.5,
    widthMultiplier: -1,
    arrow: 'right',
  },
];

export default TOUR_DATA;
